import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../ui/LoadingSpinner';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();
  const location = useLocation();

  // Debug logging
  console.log('AdminRoute Debug:', { isAuthenticated, isAdmin, isLoading, location });

  if (isLoading) {
    console.log('AdminRoute: Loading...');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('AdminRoute: Not authenticated, redirecting to login');
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    console.log('AdminRoute: Not admin, redirecting to home');
    return <Navigate to="/" replace />;
  }

  console.log('AdminRoute: Rendering children');
  return children;
};

export default AdminRoute;
